import { render } from "./Admin_Dashboard.vue?vue&type=template&id=ddde1eec&scoped=true"
import script from "./Admin_Dashboard.vue?vue&type=script&lang=js"
export * from "./Admin_Dashboard.vue?vue&type=script&lang=js"

import "./Admin_Dashboard.vue?vue&type=style&index=0&id=ddde1eec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddde1eec"]])

export default __exports__